<template>
    <div class="footer">
        <div class="copyright">
            <div class="copyright-content">亿志愿智能高报平台</div>
            <div class="copyright-content">北京祝余科技有限公司 版权所有@2024-2025</div>
            <div class="copyright-content">京ICP备2024100908号-1</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "my-footer"
}
</script>

<style lang="less" scoped>
.footer {
    height: 110px;
    font-size: 12px;
    padding-top: 18px;
    padding-bottom: 18px;
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    background-color: #333;
    color: #999;

    .copyright {
        font-size: 13px;
        margin: 0 auto;
        width: 1200px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .copyright-content {
            text-align: center;
        }

    }


}
</style>